"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportDefinitions = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const ChevronRight_1 = __importDefault(require("@material-ui/icons/ChevronRight"));
const ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
const TreeItem_1 = __importDefault(require("@material-ui/lab/TreeItem"));
const TreeView_1 = __importDefault(require("@material-ui/lab/TreeView"));
const panel_1 = require("../../../components/panel/panel");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const definitions_hook_1 = require("../hook/definitions-hook");
const reporting_styles_1 = require("../reporting-styles");
function ReportDefinitions({ selected, onSelect, }) {
    var _a;
    const intl = (0, react_intl_1.useIntl)();
    const classes = (0, reporting_styles_1.useStyles)();
    const { definitions } = (0, definitions_hook_1.useReportDefinitionsLogic)();
    const handleSelect = (0, event_callback_hook_1.useEventCallback)((e, value) => {
        if (value.startsWith('GROUP_')) {
            return;
        }
        const definition = definitions.find((definition) => definition.id === value);
        onSelect(definition);
    });
    const groups = makeHierarchy(definitions);
    return (react_1.default.createElement("div", { className: classes.wrapperDefinitions },
        react_1.default.createElement(panel_1.Panel, { label: intl.formatMessage({
                id: 'EAS_REPORTING_DEFINITIONS_PANEL_TITLE',
                defaultMessage: 'Výběr reportu',
            }), sideBorder: true, className: classes.panel, fitHeight: true }, groups.length > 0 && (react_1.default.createElement(TreeView_1.default, { selected: (_a = selected === null || selected === void 0 ? void 0 : selected.id) !== null && _a !== void 0 ? _a : '', onNodeSelect: handleSelect, defaultCollapseIcon: react_1.default.createElement(ExpandMore_1.default, null), defaultExpandIcon: react_1.default.createElement(ChevronRight_1.default, null), defaultExpanded: groups.map((g) => 'GROUP_' + g.id) }, groups.map((group) => (react_1.default.createElement(TreeItem_1.default, { key: group.id, nodeId: 'GROUP_' + group.id, label: group.label }, group.definitions.map((definition) => (react_1.default.createElement(TreeItem_1.default, { key: definition.id, nodeId: definition.id, label: definition.label })))))))))));
}
exports.ReportDefinitions = ReportDefinitions;
function makeHierarchy(items) {
    const groups = [];
    items.forEach((item) => {
        let group = groups.find((g) => g.id === item.groupId);
        if (group === undefined) {
            group = {
                id: item.groupId,
                label: item.groupLabel,
                definitions: [],
            };
            groups.push(group);
        }
        group.definitions.push({
            id: item.id,
            label: item.label,
        });
    });
    return groups;
}
//# sourceMappingURL=report-definitions.js.map